import { Component, OnInit, Input } from '@angular/core';
import { SwiperConfigInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { HttpClient } from '@angular/common/http';
import { slide } from '../../shared/services/slide.service';
import Swiper from 'swiper';

@Component({
  selector: 'app-main-carousel',
  templateUrl: './main-carousel.component.html',
  styleUrls: ['./main-carousel.component.sass']
})
export class MainCarouselComponent implements OnInit {
  @Input('slides') slides: Array<any> = [];
  public config: SwiperConfigInterface = {};
  isMobile = false;
  contentLoaded = false;

  private swiper: Swiper | null = null; // Swiper instance reference

  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    clickable: true
  };

  constructor(private http: HttpClient, private _slide: slide) {}

  ngOnInit() {
    this.isMobile = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ].some((toMatchItem) => navigator.userAgent.match(toMatchItem));

    // Fetch slides based on device type
    if (!this.isMobile) {
      this._slide.getSlider().subscribe((res) => {
        this.slides = res;
        this.updateSwiper(); // Update Swiper after loading slides
      });
    } else {
      this._slide.getSliderMobile().subscribe((res) => {
        this.slides = res;
        this.updateSwiper(); // Update Swiper after loading slides
      });
    }
  }

  ngAfterViewInit() {
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,
      keyboard: true,
      navigation: true,
      pagination: this.pagination,
      grabCursor: true,
      loop: false,
      preloadImages: true,
      lazy: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      speed: 500,
      effect: "slide",
      updateOnImagesReady: true,
    };

    // Initialize Swiper
    setTimeout(() => {
      this.swiper = new Swiper('.swiper-container', this.config);
    });
  }

  private updateSwiper() {
    if (this.swiper) {
      this.swiper.update(); // Ensure Swiper is aware of new slides
    }
  }
}
